<template>
  <div>
    <v-form
      ref="question"
      lazy-validation
      class="grid-container question-grid"
      :data-testid="testId + '-grid'"
    >
      <v-layout>
        <v-checkbox
          v-model="questionAckValue"
          :data-testid="testId + '-checkbox'"
          hide-details
          class="shrink mr-2"
          style="grid-area: questionAck"
        />

        <template style="grid-area: questionContent">
          <div>
            <slot class="content-style" ref="question"></slot>
          </div>
        </template>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    idId: String,
    testId: String,
    isChecked: Boolean,
  },

  data: function() {
    return {
      questionAckValue: this.isChecked || false,
    };
  },
  watch: {
    questionAckValue: function() {
      this.$emit("updateAck", this.questionAckValue, this.idId);
    },
    isChecked: function() {
      this.questionAckValue = this.isChecked;
    },
  },
};
</script>

<style scoped>
.question-grid {
  display: grid;
  grid-gap: 40px;
  grid-template-areas: "questionAck questionContent";
  text-align: left;
}
.content-style {
  font-family: "Roboto";
  color: #737373;
}
</style>
